import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { onAddAttributeRes } from "./helper";

const addAttribute = async (data: AttributeReqT) =>
  axios.post(Routes.ADD_ATTRIBUTE, data);

export const useAddAttribute = () =>
  useMutation({
    mutationKey: [Keys.ADD_ATTRIBUTE_MUT],
    mutationFn: addAttribute,
    onSuccess: onAddAttributeRes,
  });
